import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReportGlobalPage } from './report-global';

@NgModule({
  declarations: [
    ReportGlobalPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportGlobalPage),
  ],
})
export class ReportGlobalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-global/report-global.module.ts